module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon11.4493702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon11.png
// module id = DZ6b
// module chunks = 0